import { render, staticRenderFns } from "./gc-popup-stock-levels.vue?vue&type=template&id=0ecaa406&"
import script from "./gc-popup-stock-levels.vue?vue&type=script&lang=js&"
export * from "./gc-popup-stock-levels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports